exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.title-area__dropdown .dropdown-toggle {\n  height: 1.5rem !important;\n}\n.title-area__dropdown .dropdown-toggle .vs__actions {\n    top: 3px !important;\n}\n.title-area__dropdown .dropdown-toggle .selected-tag, .title-area__dropdown .dropdown-toggle input[type=search] {\n    height: 1.4rem !important;\n    margin: 0 !important;\n    line-height: 1.4rem !important;\n}\n.title-area__dropdown .open-indicator {\n  height: 14px !important;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"id":"data-v-5e0d7faf","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./src/tools/modal/ReservationEditV2/TitleArea.vue
// module id = 1880
// module chunks = 0